module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("c-nav-menu__category c-nav-menu__category--" + (_vm.toCssName(_vm.category)))
  }, [_c('h4', {
    staticClass: "c-nav-menu__item"
  }, [_vm._v(_vm._s(_vm.category))]), _vm._v(" "), _c('ul', {
    staticClass: "c-nav-menu__category-list"
  }, [_vm._l((_vm.filterCategory(_vm.category)), function(post) {
    return (_vm.posts) ? [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('li', {
      class: ("c-nav-menu__category-list-item " + (_vm.toCssName(_vm.category)))
    }, [_c('router-link', {
      staticClass: "c-nav-menu__category-list-link",
      attrs: {
        "to": {
          name: 'post',
          params: {
            id: post.uid
          }
        }
      }
    }, [_c('span', {}, [_vm._v(_vm._s(_vm.getTextContent(post.data.title)))])])], 1)])] : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fecafa5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenuCategory.vue
// module id = 89
// module chunks = 0